export default "<signature-pad [options]=\"options\" (onBeginEvent)=\"drawBegin()\" (onEndEvent)=\"drawComplete()\"></signature-pad>"